import React, {
  Fragment, useState, memo, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import ImgReload from './reload.svg';
import styles from './styles.scss';
import { useGameStore } from '../hooks/useGameStore';
import MoneyButtonWrapper from './MoneyButtonWrapper';
import useAppStore from '../../../useAppStore';
import useBet from '../../../games/hooks/useBet';
import useSettings from '../hooks/useSettings';
import Button from '../../Button/Button';

const cx = classNames.bind(styles);

function BetButton({
  className, buttonText, onBetSuccess, disabled, hidden, depositData,
}) {
  const isDeposit = !!depositData;
  const selectedAsset = useAppStore(state => state.asset.selected);
  const bettingData = depositData || useGameStore(state => state.bettingData);
  const { isLoading: settingsLoading } = useSettings({ enabled: !isDeposit });
  const [moneyButtonLoaded, setMoneyButtonLoaded] = useState(false);
  const currentWallet = useSelector(state => state.wallets.currentWallet);
  const isRealMode = useGameStore(state => state.isRealMode);
  const bettingDisabled = useGameStore(state => state.bettingDisabled);
  const {
    placeBet, isLoading, error, errorModals,
  } = useBet(bettingData, onBetSuccess, isDeposit);

  useEffect(() => {
    if (!settingsLoading && moneyButtonLoaded) {
      useGameStore.getState().setBettingDisabled(false);
    }
  }, [settingsLoading, moneyButtonLoaded]);

  function onBet() {
    useGameStore.getState().setBettingDisabled(true);
    if (isRealMode || isDeposit) {
      placeBet();
    } else {
      onBetSuccess();
    }
  }

  if (
    (isRealMode && (!currentWallet || currentWallet?.name === 'moneybutton') && selectedAsset !== 'PGP')
    || (currentWallet?.name === 'moneybutton' && isDeposit)
  ) {
    return (
      <MoneyButtonWrapper
        hidden={hidden}
        disabled={disabled || (!isDeposit && bettingDisabled)}
        bettingData={bettingData}
        onBetSuccess={onBetSuccess}
        setLoaded={setMoneyButtonLoaded}
        isDeposit={isDeposit}
      />
    );
  }
  // don't render anything if hidden is true
  if (hidden) {
    return null;
  }

  return (
    <Fragment>
      <div className={cx('button-container')}>
        {error ? (
          <span className={cx('bold', 'error-placeholder')}>
            {error.code === '__too_long_mempool_chain__' ? 'Speed Limit' : 'Error'}
          </span>
        ) : (
          <Button
            className={cx('bold', 'bet-button', className)}
            onClick={onBet}
            isDisabled={disabled || isLoading || (!isDeposit && bettingDisabled)}
            isLoading={isLoading}
          >
            {buttonText}
          </Button>
        )}
        {error && (
          <button className={cx('retry-button')} type="button" disabled={isLoading} onClick={() => placeBet()}>
            <img src={ImgReload} alt="" />
          </button>
        )}
      </div>
      {errorModals}
    </Fragment>
  );
}
export default memo(BetButton);

BetButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  onBetSuccess: PropTypes.func.isRequired,
  hidden: PropTypes.bool,
  depositData: PropTypes.object,
};
BetButton.defaultProps = {
  disabled: false,
  hidden: false,
  depositData: null,
};
